<template>
  <div class="px-3">
    <h3 class="ota-h2 text-center mb-3" v-text="$t('FAQ.DynamicFaq.Title')" />
    <p class="ota-p16 text-center mb-9" v-text="$t('FAQ.DynamicFaq.Description')" />
    <div class="md:grid md:grid-cols-3 md:gap-6">
      <DynamicFAQItem
        v-for="block in blocks"
        :key="block.title"
        v-bind="block"
        class="md:col-span-1 mb-12"
      />
    </div>
  </div>
</template>

<script>
import DynamicFAQItem from '@/components/DynamicFAQ/DynamicFAQItem'

export default {
  name: 'DynamicFAQ',
  components: { DynamicFAQItem },
  props: {
    blocks: {
      type: Array,
      default: () => ([]),
      validator: value => value.every(obj => ['title', 'image', 'questions'].every(prop => obj.hasOwnProperty(prop)))
    }
  }
}
</script>

<style>

</style>
